import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { DemoGym, ErrorMessage, DemoGymWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateDemoGym(): UseMutationResult<
  AxiosResponse<DemoGym>,
  AxiosError<ErrorMessage>,
  DemoGymWrite
> {
  const queryClient = useQueryClient();

  const mutationFn = (payload: DemoGymWrite): Promise<AxiosResponse<DemoGym>> => {
    return client.post('demo-gyms/', payload);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries('demoGyms');
    },
  });
}
